export class StorageBase implements NPS.Common.IStorageBase {
    public storage: NPS.Common.ITypedObject<any> = {};

    constructor() { }

    get<T>(key: string): T {
         return this.storage[key];
    }

    set<T>(key: string, data: T): void {
        this.storage[key] = data;
    }

    remove(key: string): void {
        delete this.storage[key];
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Storage/StorageBase.ts